module.exports = __webpack_public_path__ + "img/non-smoker-selected.152aa8be.svg";